import React from 'react'
import ShowComments from './ShowComments'

interface Props {
	commentsArr: number[] | undefined
}

const Comments: React.FC<Props> = ({ commentsArr }) => {
	if (!commentsArr) {
		commentsArr = []
	}

	return (
		<div>
			{commentsArr.length > 0 ? (
				<ShowComments commentsIds={commentsArr} />
			) : (
				<span className="text-muted underline">
					<i>There are no comments to show.</i>
				</span>
			)}
		</div>
	)
}

export default Comments
